import ElementUi from 'element-ui';
import fr from "element-ui/lib/locale/lang/fr"
import en from "element-ui/lib/locale/lang/en"
import de from "element-ui/lib/locale/lang/de"
import es from "element-ui/lib/locale/lang/es"

const messages = {
    fr, en, de, es
};
const defaultLanguage = 'en';
const extractLanguage = (lang) => {
    let pos = lang.indexOf("_");
    if (pos === -1) return lang;
    return lang.substring(0, pos);
}
const getLanguage = (w) => {
    if (w.document.firstElementChild) {
        return extractLanguage(w.document.firstElementChild.lang || defaultLanguage)
    }
    // parce qu'IE le vaut bien ......
    try {
        let node, nodes = w.document.childNodes, i = 0;
        while (node = nodes[i++]) {
            if (node.nodeType === 1) {
                return extractLanguage(node.lang || defaultLanguage);
            }
        }
    } catch (ee) {
        // ca va bien 5 minutes avec IE ...
    }
    return defaultLanguage; // default en ...
}

const i18n = new VueI18n({
    locale: getLanguage(window),
    fallbackLocale: defaultLanguage,
    messages
});

Vue.use(ElementUi, {
    i18n: function (path, options) {
        return i18n.t(path, options);
    },
    size: 'small',
    zIndex: 20000
})
